import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import './styles/base.css'
import api, { uploadApi } from '@/api/api'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$api = api
Vue.prototype.$uploadApi = uploadApi

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
